<template>
  <div class="">
    <div class="modalWindow1" v-drag>
      <div class="modalWindow__top">
        <p class="modalWindow--txt1">
          {{ title }}
          <span class="modalWindow--close1 fr" @click="$emit('close')"></span>
        </p>
      </div>
      <div class="main">
        <slot name="header"></slot>
      </div>
      <div class="main-btm">
        <div class="btns1" @click="$emit('submitBtn')">确认</div>
        <div class="btns" @click="$emit('close')">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title"],
  data() {
    return {};
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
.modalWindow1 {
  width: 521px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  max-height: 80%;
  overflow-y: auto;
  background: white;
  padding-bottom: 40px;

  .modalWindow--close1 {
    width: 32px;
    height: 32px;
    background: url("../../assets/images-new/icon_close2.png") no-repeat center;
    cursor: pointer;
  }

  .modalWindow__top {
    box-sizing: border-box;
    border-radius: 5px 5px 0 0;
    height: 60px;
    line-height: 60px;
    padding: 0 28px;
    background: #f0f7fa;

    .modalWindow--txt1 {
      font-size: 18px;
      color: #333;
      padding-left: 14px;
      line-height: 60px;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &::before {
        position: absolute;
        top: 50%;
        left: 0px;
        transform: translateY(-50%);
        width: 4px;
        height: 20px;
        background: #52b8cc;
        display: block;
        content: " ";
        border-radius: 10px;
      }
    }
  }

  .main {
    padding: 40px 20px;
  }

  .main-btm {
    display: flex;
    align-content: center;
    width: 280px;
    margin: 0 auto;
  }

  .btns1 {
    display: inline-block;
    width: 120px;
    height: 40px;
    border-radius: 20px;
    background-color: #52b8cc;
    font-size: 16px;
    line-height: 40px;
    margin: 0 15px;
    color: #fff;
    cursor: pointer;
    text-align: center;
    margin: auto;
  }

  .btns {
    border: 1px solid #ccc;
    display: inline-block;
    width: 120px;
    height: 40px;
    border-radius: 20px;
    background-color: #fff;
    font-size: 16px;
    line-height: 40px;
    margin: 0 15px;
    color: #666;
    cursor: pointer;
    text-align: center;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layerOpen/index.vue